var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"anzahl"},[_c('Header'),_c('Hero',{attrs:{"step":"anzahl"}}),_c('Anzahl'),_c('Footer'),_c('SlideNavigation',{attrs:{"prev-route":"bestaetigung","next-route":"/"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }